<template>
  <span>
    <b-dropdown variant="none">
      <template #button-content>
        <div class="dropdown-btn">
          <task-status :status="selectedItem.definition" :alt="selected" />
        </div>
      </template>
      <b-dropdown-item v-for="item in options" :key="'status-' + item.definition" @click="itemSelected(item)" :disabled="item.definition == selectedItem.definition">
        <task-status :status="item.definition" :onlyDot="true" />

        {{ item.name | translate }}
      </b-dropdown-item>
    </b-dropdown>
  </span>
  <!--

  <span class="multiselect-wrapper">
    <multiselect
    :value="selectedItem"
    track-by="definition"
    :placeholder="$t('task.status.text')"
    :options="options"
    :searchable="false"
    :allow-empty="false"
    :show-labels="false"
    @select="itemSelected($event)"
    >
    <template slot="singleLabel" slot-scope="{ option }">
      <task-status :status="option.definition" size="13" />
    </template>
    <template slot="option" slot-scope="{ option }">
      <task-status :status="option.definition" size="13" />
    </template>
  </multiselect>
</span>
-->
</template>

<script>
import { resolveStatuses, statusOptions } from "@/modules/task/task-settings";

export default {
  props: ["selected"],

  computed: {
    options() {
      // TKP-119: organizasyonun durum kayıtları (özel durumlar dahil), sırayla; kayıt yoksa sistem varsayılanları
      const language = this.currentLanguage;
      return statusOptions(resolveStatuses(this.$store.getters["taskSettings/statuses"], language, (k) => this.$t(k)), language);
    },

    selectedItem() {
      const language = this.currentLanguage;

      return (
        this.options.find((i) => i.definition == this.selected) ?? {
          definition: "TODO",
          name: {
            [language]: this.$t("task.status.todo"),
          },
        }
      );
    },
  },
  watch: {
    selected(v) {},
  },
  mounted() {},
  methods: {
    itemSelected(item) {
      this.selected = item.definition;
      if (item) {
        this.$emit("onSelect", item.definition);
      } else {
        this.$emit("onSelect", "TODO");
      }
    },
  },
};
</script>

<style>
.multiselect-wrapper .multiselect__option--highlight {
  background: rgb(237, 237, 237) !important;
  color: black !important;
}
.btn-none {
  padding: 0px;
}
</style>
